import { INetworkMenuProps } from 'interfaces/UserNftAndToken/userNftToken';

const NetworkMenu = (props: INetworkMenuProps) => {
  return (
    <div className="bg-white mt-2 p-2 border-fade border rounded-lg shadow-lg'">
      {props.children}
    </div>
  );
};

export default NetworkMenu;
